import { PageLayout } from '@kizi/comparator-core';

const steps = [{ title: 'Vergelijken' }, { title: 'Aanvragen' }];

const productComparisonLayout: PageLayout = {
  name: 'productComparison',
  components: [
    {
      type: 'ComparisonPage',
      props: {
        comparisonProducts: 'overview.comparisonProducts',
        contentStyles: {
          span: [12, 12, 12, 12],
        },
        bg: 'second.2',
        header: [
          {
            type: 'PageHeader',
            props: {
              steps,
              activeStep: 0,
            },
          },
        ],
        subHeader: [
          {
            type: 'Heading',
            props: {
              variant: 'H2',
              as: 'h2',
              children: 'Vergelijken',
            },
          },
          {
            type: 'GoToButtonIcon',
            props: {
              variant: 'transparentWithIcon',
              index: 1,
              children: 'Terug naar overzicht',
            },
          },
        ],
        content: [
          {
            type: 'ExperienceManager',
            props: {
              label: 'Draai je telefoon voor een betere ervaring',
            },
            _children: [
              {
                type: 'ProductComparisonContainerWrapper',
                props: {
                  labels: [
                    {
                      label: '',
                    },
                    {
                      label: 'Product',
                    },
                    {
                      label: 'Kosten per maand',
                    },
                    {
                      label: 'Kosten per jaar',
                    },
                    {
                      label: 'Kenmerken',
                    },
                    {
                      label: 'Downloadsnelheid',
                      tooltip:
                        'Downloaden: informatie die u van het internet naar uw computer toehaalt (bijv. internetsites bekijken, e-mail binnenhalen of muziek downloaden). De snelheid is weergegeven in Megabit per seconde.',
                    },
                    {
                      label: 'Testoordeel',
                    },
                    {
                      label: '',
                    },
                  ],
                  comparator: 'tripleplay',
                  section: 'overview',
                  goToIndex: 2,
                },
              },
              {
                type: 'ProductComparisonContainerWrapper',
                props: {
                  header: 'Kosten & contract',
                  labels: [
                    {
                      label: 'Eenmalige aansluitkosten',
                    },
                    {
                      label: 'Verzend- en administratiekosten',
                    },
                    {
                      label: 'Gemiddelde levertijd',
                      tooltip:
                        'De gemiddelde levertijd vanaf de aanvraag tot aan actieve levering door de aanbieder. Let op: Wanneer je al een abonnement hebt op dit adres, en je gebruikt maakt van de overstapservice, dan is de gemiddelde levertijd 30 dagen. Zo voorkom je dat je dubbel betaalt.',
                    },
                    {
                      label: 'Vrije ingangsdatum',
                      tooltip:
                        'De uiterste datum waarop je je nieuwe contract in kunt laten gaan.',
                    },
                    {
                      label: 'Contractduur',
                      tooltip: 'De minimale contractduur van dit contract.',
                    },
                    {
                      label: 'Contractverlenging',
                      tooltip:
                        'De termijn waarbij dit contract wordt verlengd na de minimale contractduur.',
                    },
                    {
                      label: 'Opzegtermijn',
                      tooltip:
                        'De opzegtermijn voor het einde van de minimale contractduur.',
                    },
                  ],
                  comparator: 'tripleplay',
                  section: 'costs',
                },
              },
              {
                type: 'ProductComparisonContainerWrapper',
                props: {
                  header: 'Internet',
                  labels: [
                    {
                      label: 'Downloadsnelheid',
                      tooltip:
                        'De maximale downloadsnelheid die haalbaar is met dit pakket. Let op: de werkelijke downloadsnelheid kan hiervan afwijken.',
                    },
                    {
                      label: 'Uploadsnelheid',
                      tooltip:
                        'De maximale uploadsnelheid die haalbaar is met dit pakket. Let op: de werkelijke uploadsnelheid kan hiervan afwijken.',
                    },
                    {
                      label: 'Modems/ontvangers',
                      tooltip:
                        'De modem(s) of ontvanger(s) die deze aanbieder meelevert.',
                    },
                    {
                      label: 'Netwerk',
                      tooltip:
                        'Het netwerk waarover de aanbieder de verbinding levert',
                    },
                    {
                      label: 'Webmail',
                      tooltip:
                        'Met webmail kun je met behulp van een internetbrowser overal ter wereld je e-mail lezen.',
                    },
                    {
                      label: 'Aantal e-mailboxen',
                      tooltip:
                        'Het aantal inbegrepen e-mailboxen met unieke loginnaam en wachtwoord.',
                    },
                    {
                      label: 'E-mailaliassen',
                      tooltip: 'Het aantal inbegrepen e-mailadressen.',
                    },
                    {
                      label: 'Grootte e-mailbox',
                      tooltip:
                        'De hoeveelheid e-mails die je kunt opslaan in MB of GB.',
                    },
                    {
                      label: 'E-mail spamfilter',
                      tooltip:
                        'Een spamfilter verwijdert automatisch ongewenste reclame uit binnengekomen e-mail.',
                    },
                    {
                      label: 'E-mail virusfilter',
                      tooltip:
                        'Een virusfilter verwijdert automatisch virussen uit binnengekomen e-mail.',
                    },
                    {
                      label: 'Homepage',
                      tooltip:
                        'Sommige aanbieders geven je de mogelijkheid gratis een homepage te publiceren.',
                    },
                    {
                      label: 'Nieuwsgroep',
                      tooltip:
                        'In een nieuwsgroep kun je bestanden uitwisselen en discussiëren met medegebruikers.',
                    },
                    {
                      label: 'Vast IP adres',
                      tooltip:
                        'Een vast IP-adres is handig als je een eigen web- of mailserver wilt gebruiken.',
                    },
                  ],
                  comparator: 'tripleplay',
                  section: 'internetPackages',
                },
              },
              {
                type: 'ProductComparisonContainerWrapper',
                props: {
                  header: 'Televisie',
                  labels: [
                    {
                      label: 'TV-zenders',
                    },
                    {
                      label: 'HD-zenders',
                      tooltip:
                        'Het aantal hd-tv-zenders dat standaard is inbegrepen bij dit product. Hd-tv biedt een veel scherper en kleurrijker beeld dan een analoog signaal.',
                    },
                    {
                      label: 'Radiozenders',
                      tooltip:
                        'Het aantal radiozenders dat standaard is inbegrepen bij dit product.',
                    },
                    {
                      label: 'Ontvangers',
                    },
                    {
                      label: 'Meer tvs aansluiten',
                      tooltip:
                        'Het aantal tv-ontvangers dat je optioneel kan bijbestellen.',
                    },
                    {
                      label: 'EPG (programmagids)',
                    },
                    {
                      label: 'Opnemen',
                    },
                    {
                      label: 'Live pauzeren',
                    },
                    {
                      label: 'Programma gemist',
                    },
                    {
                      label: 'Opnameduur',
                    },
                    {
                      label: 'Tegelijkertijd opnemen',
                    },
                    {
                      label: 'Video on demand',
                    },
                  ],
                  comparator: 'tripleplay',
                  section: 'televisionPackages',
                },
              },
              {
                type: 'ProductComparisonContainerWrapper',
                props: {
                  header: 'Bellen',
                  labels: [
                    {
                      label: 'Starttarief',
                    },
                    {
                      label: 'Bellen binnen de regio',
                      tooltip:
                        'De kosten die de aanbieder in rekening brengt voor bellen naar vaste nummers binnen je netgebied.',
                    },
                    {
                      label: 'Bellen buiten de regio',
                    },
                    {
                      label: 'Bellen naar mobiel',
                    },
                    {
                      label: 'Nummerbehoud',
                      tooltip:
                        'De mogelijkheid om je huidige telefoonnummer mee te nemen naar de nieuwe aanbieder.',
                    },
                    {
                      label: 'Nummerweergave',
                      tooltip: 'Met nummerweergave kun je zien wie er belt.',
                    },
                    {
                      label: 'Voicemail',
                      tooltip:
                        'Bij deze aanbieder kun je een voicemail instellen.',
                    },
                  ],
                  comparator: 'tripleplay',
                  section: 'callPackages',
                },
              },
            ],
          },
        ],
      },
    },
  ],
};

export default productComparisonLayout;
